import React from 'react';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { persister, renegkitQueryClient } from '../../services/query/query.service';

export const RenegQueryProvider = ({ children }: any) => (
  <PersistQueryClientProvider client={renegkitQueryClient} persistOptions={{ persister }}>
    {children}
  </PersistQueryClientProvider>
);
